// extracted by mini-css-extract-plugin
export default {"body":"body-N3dha","title":"title-UQyiq","text":"text-KKPU8"};